import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=6ab2585a&"
import script from "./SidePanel.vue?vue&type=script&lang=js&"
export * from "./SidePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports